// Equipment screen (`/equipment`) — thin wrapper over PrereqList.
import PrereqList from './PrereqList';

export default function Equipment() {
  return <PrereqList kind="equipment" heading="Equipment" />;
}
